import { default as WJElement } from '../wje-element/element.js';
import Chip from './chip.element.js';

// export * from "./chip.element.js";
export default Chip;

WJElement.define('wje-chip', Chip);
